import { computed, Signal } from '@preact/signals'

export const globalTime = new Signal({ now: Date.now(), delta: 0 })
;(function rafLoop() {
  const old = globalTime.peek()
  const now = Date.now()
  globalTime.value = { now, delta: now - old.now }
  requestAnimationFrame(rafLoop)
})()

const SEC = 1000
const MIN = SEC * 60
const HOUR = MIN * 60
const DAY = HOUR * 24

const each = (unit: number) =>
  computed(() => Math.floor(globalTime.value.now / unit) * unit)

export const eachSec = each(SEC)
export const eachMin = each(MIN)
export const eachHour = each(HOUR)
export const eachDay = each(DAY)
